import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { AdditionalDocument } from "../types/AdditionalDocumentsType";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string, id: number) => () =>
  axios.get<AdditionalDocument>(`${env.verifyServiceUrl}individual/additional_document/${id}/`, {
    headers: {
      Authorization: authHeader,
    },
  }).then(response => response.data); // Return only the data part of the response

export const useAdditionalDocumentById = (id: number, enabled: boolean) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["documentDetails", id], fetch(authHeader, id), {
    enabled,
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
